import React from "react"
import styled from "styled-components"
import useSearch from "../../../hooks/useSearch"
import * as Icons from "@bw/icons"
import { Research } from "@bw/partials"
import { Modal } from "@bw/partials"
import { useTranslation } from "react-i18next"

const Button = styled.button`
  color: currentColor;
  display: block;
  cursor: pointer;
  background: none;
  border: 0;
`

const Search = () => {
  const { t } = useTranslation()
  const [show, setShow] = React.useState(false)
  const [filter, setFilter] = React.useState({})
  const { isLoading, fuse, collections, history } = useSearch()

  React.useEffect(() => {
    const handleSlash = event => {
      if (
        document.activeElement === document.body &&
        event.keyCode === 55 &&
        event.shiftKey
      ) {
        setShow(true)
      }
    }

    window.addEventListener("keydown", handleSlash)

    return () => {
      window.removeEventListener("keydown", handleSlash)
    }
  }, [])

  const filters = React.useMemo(
    () =>
      collections.map(collection => ({
        title: t(`collections.${collection}.plural`),
        value: collection,
      })),
    [collections, t]
  )

  const results = React.useMemo(() => {
    let results = []

    if (filter.search) {
      results = fuse.search(filter.search).map(r => ({
        ...r.item,
        type: t(`collections.${r.item.collection}.plural`),
        to: r.item.url,
      }))

      if (filter.collection && filter.collection.length > 0) {
        results = results.filter(r => filter.collection.includes(r.collection))
      }
    }

    return results
  }, [filter, fuse, t])

  return (
    <>
      <Button
        onClick={() => {
          if (!isLoading) {
            setShow(true)
          }
        }}
      >
        <Icons.Search fillColor="currentColor" />
      </Button>
      <Modal
        {...{
          show,
          setShow,
          onVisibilityChange: visible => {
            if (visible) {
              setTimeout(() => {
                document.getElementById("search-input").focus()
              }, 30)
            }
          },
        }}
        children={
          <Research
            results={results}
            filters={filters}
            history={history}
            onSelect={() => {
              setShow(false)
            }}
            onFilter={values => {
              setFilter(values)
            }}
          />
        }
      />
    </>
  )
}

export default Search
